import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { AlertTriangle, MessageSquare, Clock, ChevronDown, CheckCircle } from 'lucide-react';
const ORDER_TABS = [{
  label: 'Live Queue',
  path: ''
}, {
  label: 'Flagged (3)',
  path: 'flagged'
}, {
  label: 'Order History',
  path: 'history'
}, {
  label: 'Analytics',
  path: 'analytics'
}];
const FLAGGED_ORDERS = [{
  id: '#4502',
  channel: 'Wolt',
  location: 'Vračar',
  time: 'Today 13:45',
  issue: 'LOW RATING (6/10)',
  severity: 'high',
  comment: 'Food arrived cold, burger was soggy. Very disappointed.',
  details: '2x Double Smash, 1x Pomfrit — 1,890 RSD',
  prep: '18 min (est was 10 min ⚠️)',
  wait: '8 min'
}, {
  id: '#4498',
  channel: 'Wolt',
  location: 'BB',
  time: 'Today 12:30',
  issue: 'NEGATIVE COMMENT',
  severity: 'medium',
  comment: 'Missing sauce, asked for extra ketchup but got none',
  rating: '8/10'
}];
const RESOLVED_ORDERS = [{
  id: '#4456',
  issue: 'Low rating',
  resolver: 'Jovana',
  note: 'Contacted customer, offered discount'
}, {
  id: '#4432',
  issue: 'Missing item',
  resolver: 'Marko',
  note: 'Refund processed via Wolt'
}, {
  id: '#4401',
  issue: 'Negative comment',
  resolver: 'Jovana',
  note: 'Customer complaint addressed'
}];
export function Flagged() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2555">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-2556">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-2557">Flagged Orders</h1>
        <div className="flex items-center gap-3" data-id="element-2558">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-2559">
            All Locations <ChevronDown size={14} data-id="element-2560" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-2561">
            All Time <ChevronDown size={14} data-id="element-2562" />
          </button>
        </div>
      </div>

      <TabNavigation tabs={ORDER_TABS} basePath="/orders" data-id="element-2563" />

      <div className="space-y-8" data-id="element-2564">
        {/* Active Issues */}
        <div data-id="element-2565">
          <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm mb-4 flex items-center gap-2" data-id="element-2566">
            Needs Attention{' '}
            <span className="bg-accent-error text-white px-2 py-0.5 rounded-full text-xs" data-id="element-2567">
              3
            </span>
          </h3>

          <div className="space-y-4" data-id="element-2568">
            {FLAGGED_ORDERS.map(order => <Card key={order.id} className="border-l-4 border-l-accent-error" data-id="element-2569">
                <div className="flex justify-between items-start mb-4" data-id="element-2570">
                  <div className="flex items-center gap-3" data-id="element-2571">
                    <div className={`w-2 h-2 rounded-full ${order.severity === 'high' ? 'bg-accent-error' : 'bg-accent-warning'}`} data-id="element-2572"></div>
                    <span className="font-bold text-lg" data-id="element-2573">{order.id}</span>
                    <span className="text-text-secondary text-sm" data-id="element-2574">
                      · {order.channel} · {order.location} · {order.time}
                    </span>
                  </div>
                  <Button size="sm" variant="secondary" data-id="element-2575">
                    Resolve
                  </Button>
                </div>

                <div className="bg-background-elevated/50 rounded-lg p-4 mb-4" data-id="element-2576">
                  <div className="font-bold text-accent-error mb-2 flex items-center gap-2" data-id="element-2577">
                    <AlertTriangle size={16} data-id="element-2578" />
                    Issue: {order.issue}
                  </div>
                  <div className="flex gap-3 text-sm italic text-text-primary bg-white/5 p-3 rounded" data-id="element-2579">
                    <MessageSquare size={16} className="shrink-0 mt-0.5 text-text-secondary" data-id="element-2580" />
                    "{order.comment}"
                  </div>
                </div>

                {order.details && <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-text-secondary mb-4" data-id="element-2581">
                    <div data-id="element-2582">
                      Order:{' '}
                      <span className="text-text-primary" data-id="element-2583">{order.details}</span>
                    </div>
                    <div data-id="element-2584">
                      Prep:{' '}
                      <span className="text-text-primary" data-id="element-2585">{order.prep}</span>
                    </div>
                    <div data-id="element-2586">
                      Pickup wait:{' '}
                      <span className="text-text-primary" data-id="element-2587">{order.wait}</span>
                    </div>
                  </div>}

                <div className="flex gap-3 pt-4 border-t border-white/5" data-id="element-2588">
                  <input type="text" placeholder="Add resolution note..." className="flex-1 bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" data-id="element-2589" />
                  <Button size="sm" data-id="element-2590">Mark Resolved</Button>
                </div>
              </Card>)}
          </div>
        </div>

        {/* Resolved History */}
        <div data-id="element-2591">
          <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm mb-4" data-id="element-2592">
            Resolved (12 this week)
          </h3>
          <Card noPadding data-id="element-2593">
            <div className="divide-y divide-white/5" data-id="element-2594">
              {RESOLVED_ORDERS.map(order => <div key={order.id} className="p-4 flex items-center justify-between hover:bg-white/5 transition-colors" data-id="element-2595">
                  <div className="flex items-center gap-3" data-id="element-2596">
                    <CheckCircle size={16} className="text-accent-success" data-id="element-2597" />
                    <span className="font-bold text-sm" data-id="element-2598">{order.id}</span>
                    <span className="text-text-secondary text-sm" data-id="element-2599">
                      · {order.issue}
                    </span>
                  </div>
                  <div className="text-sm text-text-secondary" data-id="element-2600">
                    Resolved by{' '}
                    <span className="text-text-primary font-medium" data-id="element-2601">
                      {order.resolver}
                    </span>{' '}
                    · "{order.note}"
                  </div>
                </div>)}
            </div>
          </Card>
        </div>
      </div>
    </div>;
}